import { DialogContent, DialogActions, Button, TextField, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useRaiseSupportRequestMutation } from '@/utils/utilsApi/miscApi';
import { useAppDispatch } from '@/store/hooks';
import { closeDialog } from '@fuse/core/FuseDialog/fuseDialogSlice';
import { showMessage } from '@fuse/core/FuseMessage/fuseMessageSlice';
import { ModalHeader } from './index';

const requestTypes = [
    { value: 'technical', label: 'Technical Support' },
    { value: 'billing', label: 'Billing Issue' },
    { value: 'account', label: 'Account Management' },
    { value: 'general', label: 'General Inquiry' },
    { value: 'other', label: 'Other' }
];

/**
 * SupportRequestModal component
 * Modal for users to raise support requests
 */
function SupportRequestModal() {
    const dispatch = useAppDispatch();
    const [requestType, setRequestType] = useState('general');
    const [subject, setSubject] = useState('');
    const [description, setDescription] = useState('');

    const [raiseSupportRequest, { isLoading }] = useRaiseSupportRequestMutation();

    const handleSubmit = async () => {
        try {
            const requestTypeLabel = requestTypes.find(rt => rt.value === requestType)?.label || requestType;
            const fullSubject = `[${requestTypeLabel}] ${subject}`;

            await raiseSupportRequest({
                subject: fullSubject,
                message: description
            }).unwrap();

            dispatch(closeDialog());
            dispatch(showMessage({
                message: 'Support request submitted successfully!',
                variant: 'success'
            }));
        } catch (error) {
            console.warn('Failed to submit support request:', error);
            dispatch(showMessage({
                message: 'Failed to submit support request. Please try again.',
                variant: 'error'
            }));
        }
    };

    return (
        <>
            <ModalHeader title="Raise a Support Request" />
            <DialogContent>
                <div className="flex flex-col gap-16 py-16">
                    <TextField
                        select
                        label="Request Type"
                        value={requestType}
                        onChange={(e) => setRequestType(e.target.value)}
                        fullWidth
                        required
                    >
                        {requestTypes.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>

                    <TextField
                        label="Subject"
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        fullWidth
                        required
                    />

                    <TextField
                        label="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        multiline
                        rows={6}
                        fullWidth
                        required
                        placeholder="Please describe your issue or inquiry in detail..."
                    />
                </div>
            </DialogContent>
            <DialogActions className="px-24 py-16">
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleSubmit}
                    disabled={!subject || !description || isLoading}
                >
                    {isLoading ? 'Submitting...' : 'Submit Request'}
                </Button>
            </DialogActions>
        </>
    );
}

export default SupportRequestModal;
